// eslint-disable-next-line import/prefer-default-export
export const DEFAULT_CONFIRMATION_MSG = "Are you sure you want to leave? You have unsaved changes.";
